import { useEffect, useState } from 'react';
import { DataProviderInstance } from '../../../../api/DataProvider';

/**
 * Quantidades em uso para comparar com os limites do plano.
 * null enquanto a contagem ainda não chegou.
 */
const usePlanUsage = () => {
  const { GetCompanyResources, GetCompanyUsers, GetCompanyRooms, GetCompanyProcedures } = DataProviderInstance();

  const [usage, setUsage] = useState({
    resources: null,
    users: null,
    pendingInvites: 0,
    rooms: null,
    procedures: null,
  });

  useEffect(() => {
    GetCompanyResources((result) => {
      // eslint-disable-next-line eqeqeq
      const active = (result || []).filter(r => r.Active == 1).length;
      setUsage(prev => ({ ...prev, resources: active }));
    });
    GetCompanyUsers((result) => {
      // Mesma conta do servidor (seats): pessoas ativas + convites pendentes válidos
      const seats = result?.seats;
      const active = (result?.users || []).filter(u => u.type !== 'invitation' && u.status === 'active').length;
      const pendingInvites = seats ? Number(seats.pendingInvites) || 0 : 0;
      const total = seats ? Number(seats.total) || active : active;
      setUsage(prev => ({ ...prev, users: total, pendingInvites }));
    });
    // Salas e procedimentos: só os ativos contam no limite (mesma régua do PlanFitService)
    GetCompanyRooms((result) => {
      const count = Array.isArray(result) && !result.error ? result.filter(r => r.is_active).length : 0;
      setUsage(prev => ({ ...prev, rooms: count }));
    });
    GetCompanyProcedures((result) => {
      // eslint-disable-next-line eqeqeq
      const count = Array.isArray(result) && !result.error ? result.filter(p => p.Active == 1).length : 0;
      setUsage(prev => ({ ...prev, procedures: count }));
    });
  // Só ao montar: as funções do DataProvider não são estáveis
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return usage;
};

export default usePlanUsage;
